import React from "react";
import { Card, CardBody, CardHeader } from "shards-react";
import { Line } from 'react-chartjs-2';
const options = {
  responsive: true,
  maintainAspectRatio: true,
  legend: {
    position: "top"
  },
  elements: {
    line: {
      // A higher value makes the line look skewed at this ratio.
      tension: 0.3
    },
    point: {
      radius: 0
    }
  },
  scales: {
    xAxes: [
      {
        gridLines: false,
        ticks: {
          callback(tick, index) {
            // Jump every 7 values on the X axis labels to avoid clutter.
            return index % 7 !== 0 ? "" : tick;
          }
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          suggestedMax: 45,
          callback(tick) {
            if (tick === 0) {
              return tick;
            }
            // Format the amounts using Ks for thousands.
            return tick > 999 ? `${(tick / 1000).toFixed(1)}K` : tick;
          }
        }
      }
    ]
  },
  hover: {
    mode: "nearest",
    intersect: false
  },
  tooltips: {
    custom: false,
    mode: "nearest",
    intersect: false
  }

}

export default class LineChartBig extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: this.props.title,
      data: this.props.data,
      increase: this.props.increase,
      total: this.props.total,
      percentage: this.props.percentage,
    }
  }

  render() {
    const { title, data } = this.state;

    return (
      <Card className="mb-4 card-custom h-100 ">
        <CardHeader className="card-charts-title">
          <h6 className="select-none">{title}</h6>
          <select className="form-control">
            <option value="30">Last 30 days</option>
            <option value="60">Last 2 months</option>
            <option value="90">Last 3 months</option>
          </select>
        </CardHeader>
        <CardBody className="line-lg-charts-box">
          <div className="charts-line-wrapper">
            <Line data={data} options={options} />
          </div>
        </CardBody>
      </Card>

    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashChartsComponent/lineChartBig.js